export default __webpack_public_path__ + "static/media/logo.301b7710.gif";